
import React from "react";
import { FooterText, StyledFooterContainer } from "./styles";
const Footer = () => {
   return(
      <StyledFooterContainer>
        <FooterText>
          CERTIFICADO DE AUTORIZAÇÃO SPA/ME Nº 04.039911/2025
        </FooterText>
      </StyledFooterContainer>
    );
  };
  export default Footer;